import {PaymentFieldsState} from '@dms/api/sales';

import {getSafely} from 'shared/web';

export const getIsFieldRequired =
  (fieldState: PaymentFieldsState) => (key: keyof PaymentFieldsState) => {
    const field = getSafely(fieldState, key);

    return (field?.isRequired ?? false) && field?.state !== 'HIDDEN';
  };
